import api from '@/common/api'

// 初始状态
const state = {
  token: '', // 用户令牌
  userInfo: null, // 用户信息
  roles: '', // 用户角色
  permissions: [], // 用户权限
  isLogin: false, // 登录状态
  timId: 1600071710 // 是否显示聊天
}

// getter
const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  roles: state => state.roles,
  permissions: state => state.permissions,
  isLogin: state => state.isLogin,
  timId: state => state.timId,
  // 用户姓名
  userName: state => (state.userInfo ? state.userInfo.nickName || state.userInfo.nickName : ''),
  // 用户头像
  avatar: state => (state.userInfo ? state.userInfo.headerImage : ''),
}

// 修改状态的方法（同步）
const mutations = {
  // 设置token
  SET_TOKEN(state, token) {
    state.token = token
  },
  // 设置用户信息
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  // 设置角色
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  // 设置权限
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
  // 设置登录状态
  SET_LOGIN_STATE(state, isLogin) {
    state.isLogin = isLogin
  },
  // 清除用户信息
  CLEAR_USER_INFO(state) {
    state.token = ''
    state.userInfo = null
    state.roles = []
    state.permissions = []
    state.isLogin = false
  }
}

// 异步操作
const actions = {
  // 登录
  async login({ commit }, loginData) {
    try {
      const res = await api.user.login(loginData)
      if (res.code == 200) {
        let token = res.data.token
        // 保存token
        localStorage.setItem('token', token)
        commit('SET_TOKEN', token)
        // 设置登录状态
        commit('SET_LOGIN_STATE', true)
        // 保存角色
        commit('SET_ROLES', loginData.type)
      }
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // 获取用户信息
  async getUserInfo({ commit }) {
    try {
      const res = await api.user.getUserInfo()
      if (res.code == 200) {
        // 保存用户信息
        commit('SET_USER_INFO', res.data)
      }
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // 退出登录
  async logout({ commit }) {
    try {
      // await api.user.logout()
      // 清除用户信息
      commit('CLEAR_USER_INFO')
      // 清除localStorage中的token
      localStorage.removeItem('token')
      return true
    } catch (error) {
      // 即使退出登录失败，也清除本地信息
      commit('CLEAR_USER_INFO')
      localStorage.removeItem('token')
      return Promise.reject(error)
    }
  },

  // 更新用户信息
  async updateUserInfo({ commit }, userData) {
    try {
      const res = await api.user.updateInfo(userData)
      // 更新用户信息
      commit('SET_USER_INFO', { ...state.userInfo, ...userData })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // 刷新token（如果后端支持）
  async refreshToken({ commit }) {
    try {
      const res = await api.user.refreshToken()
      commit('SET_TOKEN', res.token)
      localStorage.setItem('token', res.token)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 